// Angular
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// RxJS
import { Observable } from 'rxjs';
// CRUD
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../../core/_base/crud';
// Models
import { Electrical } from '../../../core/auth/_models/electrical.model';
const API_ENTITY_ACB_URL = '/api/electricalACB';
const API_ENTITY_MCCB_URL = '/api/electricalMCCB';

@Injectable()
export class ElectricalService {
  constructor(private http: HttpClient, private httpUtils: HttpUtilsService) {}

  getTableData(): Observable<Electrical[]> {
    return this.http.get<Electrical[]>(API_ENTITY_ACB_URL);
  }
  getTableDataMCCB(): Observable<Electrical[]> {
    return this.http.get<Electrical[]>(API_ENTITY_MCCB_URL);
  }
}
